/** INR / count formatting aligned with Business Reports conventions. */
export function formatInr(value: number, maxFractionDigits = 0): string {
  if (!Number.isFinite(value)) return "—";
  return `₹${value.toLocaleString("en-IN", { maximumFractionDigits: maxFractionDigits })}`;
}

export function formatCount(value: number): string {
  if (!Number.isFinite(value)) return "—";
  return value.toLocaleString("en-IN");
}

export function formatPercentChange(value: number | null): string {
  if (value === null || !Number.isFinite(value)) return "—";
  const sign = value > 0 ? "+" : "";
  return `${sign}${value.toLocaleString("en-IN", { maximumFractionDigits: 1 })}%`;
}

export function formatKpiValue(unit: string, value: number): string {
  if (unit === "CURRENCY_INR") return formatInr(value, 0);
  if (unit === "HOURS") return formatHours(value);
  return formatCount(value);
}

export function formatHours(value: number): string {
  if (!Number.isFinite(value)) return "—";
  return `${value.toLocaleString("en-IN", { maximumFractionDigits: 1 })} hrs`;
}

export function formatSnapshotDate(isoDate: string): string {
  try {
    const parts = isoDate.split("-");
    const y = parts[0];
    const m = parts[1];
    const d = parts[2];
    if (!y || !m || !d) return isoDate;
    const dt = new Date(Number(y), Number(m) - 1, Number(d));
    return dt.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return isoDate;
  }
}

export function formatChartDate(dateKey: string): string {
  const parts = dateKey.split("-");
  const d = parts[2];
  const m = parts[1];
  if (!m || !d) return dateKey;
  return `${d}/${m}`;
}
